var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vuelidate-form",
    {
      attrs: {
        validator: _vm.isValidator ? _vm.$v[_vm.id] : null,
        "validator-params": Object.assign({}, _vm.errMsgParam, {
          validatorParams: _vm.validatorParams
        }),
        messages: _vm.errMsg
      }
    },
    [
      _c(
        "div",
        {
          class: [
            _vm.cssHide ? "form-text-field" : "",
            _vm.isValidator && (_vm.$v.$error || _vm.customError) ? "error" : ""
          ]
        },
        [
          _vm.label || _vm.$t(_vm.labelI18n)
            ? _c(
                "label",
                { staticClass: "form-label", attrs: { for: "textfield1" } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.label || _vm.$t(_vm.labelI18n)) + " "
                  ),
                  _vm.isValidator &&
                  _vm.useRequired &&
                  (_vm.label || _vm.labelI18n)
                    ? _c("required")
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              class: [
                "input-text-field",
                _vm.useRightIcon ? "right-icon" : "",
                _vm.phone ? "phone" : ""
              ]
            },
            [
              _c("input", {
                ref: "input",
                class: ["form-control"],
                attrs: {
                  type: _vm.type,
                  disabled: _vm.disabled,
                  placeholder: _vm.$t(_vm.placeholder)
                },
                domProps: { value: _vm.value },
                on: {
                  input: _vm.inputEvent,
                  focus: _vm.onFocus,
                  blur: _vm.onBlur,
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.onKeydownEnter($event)
                  }
                }
              }),
              _vm.value != "" &&
              _vm.value != "0" &&
              _vm.isNumericComma &&
              _vm.value != "" &&
              !_vm.isNumericComma &&
              !_vm.disabled &&
              !_vm.isFixLength &&
              (!_vm.isValidator || !_vm.$v.$error) &&
              !_vm.customError
                ? _c("i", {
                    staticClass: "icon icon-del",
                    on: { click: _vm.initInputText }
                  })
                : _vm._e(),
              _vm.isValidator && (_vm.$v.$error || _vm.customError)
                ? _c("i", { staticClass: "icon icon-warning" })
                : _vm._e(),
              _vm.value != "" &&
              _vm.isValidator &&
              _vm.isFixLength &&
              !_vm.$v.$invalid
                ? _c("i", { staticClass: "icon icon-success" })
                : _vm._e()
            ]
          )
        ]
      ),
      _vm.customError
        ? _c("div", { staticClass: "validate" }, [_vm._t("error")], 2)
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }